var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "g2001",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.5,
    height: 17.5,
    viewBox: "0 0 17.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2007",
    d: "M0-682.665H17.5v17.5H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2005",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2011",
    transform: "translate(0.684 0.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2013",
    d: "M-306.6-613.2a8.067,8.067,0,0,1-8.066-8.066,8.066,8.066,0,0,1,8.066-8.066,8.066,8.066,0,0,1,8.066,8.066A8.067,8.067,0,0,1-306.6-613.2Z",
    transform: "translate(314.666 629.332)",
    fill: "#d1131d",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_68741",
    "data-name": "Group 68741",
    transform: "translate(4.888 5.64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2015",
    transform: "translate(0.991 5.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2017",
    d: "M0,1.641A3.718,3.718,0,0,1,2.871,0,3.718,3.718,0,0,1,5.742,1.641",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2021",
    d: "M-227.351-32.479a.854.854,0,0,0,.854.854.855.855,0,0,0,.854-.854.855.855,0,0,0-.854-.854.854.854,0,0,0-.854.854m-5.127-.854a.855.855,0,0,1,.854.854.855.855,0,0,1-.854.854.854.854,0,0,1-.854-.854.854.854,0,0,1,.854-.854",
    transform: "translate(233.333 33.333)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledNegative);
export default __webpack_public_path__ + "static/media/filled-negative.5340c2d79db7782bc71c1f8541a27098.svg";
export { ForwardRef as ReactComponent };